import React, { useEffect, useState } from 'react';
import { Location } from 'react-router-dom';
// Prompt has been removed in react-router-dom v6
// Using beforeunload event instead
const Prompt = ({ when, message }: { when: boolean; message: string }) => {
  React.useEffect(() => {
    if (when) {
      const handleBeforeUnload = (e: BeforeUnloadEvent) => {
        e.preventDefault();
        e.returnValue = message;
      };
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }
  }, [when, message]);
  
  return null;
};;
import { Modal } from 'antd';

interface Props {
    title: string;
    when?: boolean | undefined;
    navigate: (path: string) => void;
    shouldBlockNavigation: (location: Location) => boolean;
}
const RouteLeavingGuard = ({ title, when, navigate, shouldBlockNavigation }: Props) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [lastLocation, setLastLocation] = useState<Location | null>(null);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);
    const closeModal = () => {
        setModalVisible(false);
    };
    const handleBlockedNavigation = (nextLocation: Location): boolean => {
        if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
            setModalVisible(true);
            setLastLocation(nextLocation);
            return false;
        }
        return true;
    };
    const handleConfirmNavigationClick = () => {
        setModalVisible(false);
        setConfirmedNavigation(true);
    };

    useEffect(() => {
        if (confirmedNavigation && lastLocation) {
            navigate(lastLocation.pathname);
        }
        if (modalVisible) {
            showConfirm(title, handleConfirmNavigationClick, closeModal);
        }
    }, [confirmedNavigation, lastLocation]);

    const showConfirm = (content: string, onOkFunc: () => void, onCancelFunc: () => void) => {
        Modal.confirm({
            title,
            onOk() {
                onOkFunc();
            },
            onCancel() {
                onCancelFunc();
            }
        });
    };
    return (
        <>
            <Prompt when={when || false} message={title} />
        </>
    );
};
export default RouteLeavingGuard;
